module.exports = "header {\n  margin-left: 0 !important;\n  padding-top: 17px;\n  padding-bottom: 17px;\n  clear: both; }\n  header .col-2, header section {\n    padding: 0; }\n  header i.icon-back {\n    font-size: 1.5rem;\n    text-align: left;\n    line-height: 40px; }\n  header h2 {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/top-bar/top-bar.component.scss
// module id = ./src/app/shared/top-bar/top-bar.component.scss
// module chunks = main